import { connect } from 'react-redux';

import { clearGlobalError } from '@/store/reducers/global/actions';

import { PageNotFound } from './PageNotFound';

const mapActionsToProps = { clearGlobalError };

export default connect(null, mapActionsToProps)(PageNotFound);
